import React, { createContext, useRef } from "react";
import { SideMenuProvider } from "./SideMenuProvider";
import { SearchProvider } from "./SearchContext";
import { MainSubmenuProvider } from "./MainSubmenuProvider";
import { CartProvider } from "./CartProvider";

export const NavbarRefContext = createContext<React.RefObject<HTMLDivElement> | null>(null);

export const NavigationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const navbarRef = useRef<HTMLDivElement>(null);

  return (
    <NavbarRefContext.Provider value={navbarRef}>
      <SideMenuProvider>
        <SearchProvider>
          <MainSubmenuProvider>
            <CartProvider>
              {children}
            </CartProvider>
          </MainSubmenuProvider>
        </SearchProvider>
      </SideMenuProvider>
    </NavbarRefContext.Provider>
  );
};
